import React, {FC} from "react"

import {OuterContainer, ImageContainer, StyledImage} from "./styled"

const IMAGE_SIZE = 100

interface Props {
  image: string
}

const ModalHeaderImage: FC<Props> = ({image}) => {
  return (
    <ImageContainer size={IMAGE_SIZE}>
      <OuterContainer size={IMAGE_SIZE}>
        <StyledImage src={image} size={IMAGE_SIZE} alt="modal_image" />
      </OuterContainer>
    </ImageContainer>
  )
}

export default ModalHeaderImage
